import React from 'react'
import { sortBy } from 'lodash-es'
import { Box, Timeline, TimelineProps } from '@node-space/ui-components'
import { InternalTransferTransactionActivities } from 'types/transaction'

interface InternalTransferTransactionActivityProps {
  transactionActivities: InternalTransferTransactionActivities[]
}

const LAST_STEP = 4

const InternalTransferTransactionActivity = ({
  transactionActivities,
}: InternalTransferTransactionActivityProps) => {
  const activities: TimelineProps['items'] = sortBy(transactionActivities, ['step'])?.map(
    activity => {
      return {
        variant: activity?.step === LAST_STEP ? 'success' : 'info',
        date: new Date(activity?.dateCreated),
        Title: <span>{activity?.description ?? ''}</span>,
      }
    }
  )

  return (
    <Box paddingB={16}>
      <Timeline items={activities} />
    </Box>
  )
}
export default InternalTransferTransactionActivity
